var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dog)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('pet-settings',{attrs:{"dog":_vm.dog}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }